import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconThumbUpLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.692 8.5c.476 0 .896.182 1.26.547.366.365.548.785.548 1.26v1.616c0 .105-.014.217-.04.338a3.88 3.88 0 0 1-.09.335l-2.867 6.763c-.143.32-.383.59-.72.81a1.9 1.9 0 0 1-1.056.331H7.212v-12l5.817-5.767a1.207 1.207 0 0 1 1.442-.222c.24.129.415.31.527.547.112.236.135.48.071.732L13.992 8.5h6.7Zm-11.98.638V19h9.019c.07 0 .142-.02.216-.058a.372.372 0 0 0 .169-.192L21 12v-1.692a.3.3 0 0 0-.087-.222.3.3 0 0 0-.22-.086h-8.597l1.254-5.48-4.639 4.618ZM4.307 20.5a1.74 1.74 0 0 1-1.277-.531 1.74 1.74 0 0 1-.531-1.277v-8.384c0-.497.177-.923.531-1.277A1.74 1.74 0 0 1 4.308 8.5h2.904V10H4.308a.3.3 0 0 0-.221.086.3.3 0 0 0-.087.222v8.384a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h2.904v1.5H4.309Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconThumbUpLine;
